document.addEventListener("DOMContentLoaded", function () {
  
  let parent_menu = document.querySelectorAll('.header__grandparent__links');
  if( parent_menu ){
    
    parent_menu.forEach(function(parent) {
      
      let dropdown_menu = parent.querySelectorAll('.dropdown__family');
      if( dropdown_menu ){
        dropdown_menu.forEach(function(menu) {
          menu.addEventListener('mouseenter', function() {
            
            menu.closest('.header__grandparent__links').querySelectorAll('.dropdown__sub-family .wim-nav-slider').forEach(function(subMenu) {
              
              let menu_item = document.querySelector(`.${ subMenu.getAttribute('data-menu-item') }`);
              menu_item.classList.add('is-active');
              if( menu.getAttribute('data-nav-slider') === subMenu.id ){
                document.querySelector(`[data-nav-slider="${ subMenu.id }"]`).classList.add('is-active');
                subMenu.classList.add('is-active');
              } 
              else {
                document.querySelector(`[data-nav-slider="${ subMenu.id }"]`).classList.remove('is-active');
                menu_item.classList.remove('is-active');
                subMenu.classList.remove('is-active');
              };
            });
          });
        });
      }
    });
  }

  let content_sliders = document.querySelectorAll('.wim-nav-slider');
  if( content_sliders ){

    content_sliders.forEach(function(content_slider) {
      
      const slider = content_slider.querySelector('.wim-nav-grid-slider');
      const btn_prev = content_slider.querySelector('.slider__button--prev');
      const btn_next = content_slider.querySelector('.slider__button--next');
      if (!slider || !btn_prev || !btn_next) return;
      const scrollAmount = 200; // píxeles a desplazar por click

      btn_prev.addEventListener('click', () => {
        slider.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
      });

      btn_next.addEventListener('click', () => {
        slider.scrollBy({ left: scrollAmount, behavior: 'smooth' });
      });
    });
  }

  // Inicializar scrollbar con flechas para elementos upsell-list-grid
  function initUpsellScrollbars() {
    const upsellGrids = document.querySelectorAll('.upsell-list-grid[data-scrollbar]');
    
    upsellGrids.forEach((scrollbar) => {
      // Verificar si ya está inicializado
      if (scrollbar.hasAttribute('data-scrollbar-initialized')) {
        return;
      }

      const arrowNext = scrollbar.parentNode.querySelector('[data-scrollbar-arrow-next]');
      const arrowPrev = scrollbar.parentNode.querySelector('[data-scrollbar-arrow-prev]');

      if (!arrowNext || !arrowPrev) {
        return;
      }

      // Función para mostrar/ocultar flechas según la posición del scroll
      function toggleArrows() {
        const scrollLeft = scrollbar.scrollLeft;
        const scrollWidth = scrollbar.scrollWidth;
        const clientWidth = scrollbar.clientWidth;
        const isAtStart = scrollLeft <= 0;
        const isAtEnd = Math.round(scrollLeft + clientWidth + 1) >= scrollWidth;

        // Usar setTimeout para evitar parpadeos
        setTimeout(() => {
          arrowPrev.classList.toggle('is-hidden', isAtStart);
          arrowNext.classList.toggle('is-hidden', isAtEnd);
        }, 200);
      }

      // Función para desplazar hacia adelante
      function goToNext() {
        const moveWith = scrollbar.getBoundingClientRect().width / 2;
        const position = moveWith + scrollbar.scrollLeft;
        
        scrollbar.scrollTo({
          top: 0,
          left: position,
          behavior: 'smooth'
        });

        arrowPrev.classList.remove('is-hidden');
        toggleArrows();
      }

      // Función para desplazar hacia atrás
      function goToPrev() {
        const moveWith = scrollbar.getBoundingClientRect().width / 2;
        const position = scrollbar.scrollLeft - moveWith;
        
        scrollbar.scrollTo({
          top: 0,
          left: position,
          behavior: 'smooth'
        });

        arrowNext.classList.remove('is-hidden');
        toggleArrows();
      }

      // Event listeners
      arrowNext.addEventListener('click', (event) => {
        event.preventDefault();
        goToNext();
      });

      arrowPrev.addEventListener('click', (event) => {
        event.preventDefault();
        goToPrev();
      });

      scrollbar.addEventListener('scroll', toggleArrows);

      // Inicializar estado de las flechas
      toggleArrows();

      // Revisar cuando cambia el tamaño de la ventana
      window.addEventListener('resize', () => {
        setTimeout(toggleArrows, 200);
      });

      // Marcar como inicializado
      scrollbar.setAttribute('data-scrollbar-initialized', 'true');
    });
  }

  // Inicializar al cargar la página
  initUpsellScrollbars();

  // Observar cambios en el DOM para inicializar elementos cargados dinámicamente
  const upsellObserver = new MutationObserver(() => {
    initUpsellScrollbars();
  });

  // Observar el body para detectar nuevos elementos upsell
  const body = document.body;
  if (body) {
    upsellObserver.observe(body, {
      childList: true,
      subtree: true
    });
  }

  // También escuchar eventos de Shopify cuando se carga contenido dinámicamente
  document.addEventListener('shopify:section:load', initUpsellScrollbars);
  document.addEventListener('shopify:section:reorder', initUpsellScrollbars);
});
/* WPO (feature/cro-wpo-seo-geo): vídeos de fichas de producto en listados.
   snippets/wim-card-video.liquid los pinta sin autoplay ni precarga; aquí se
   reproducen solo mientras son visibles (al menos la mitad) y se pausan al salir.
   Un vídeo oculto en el carrusel de hover o fuera de pantalla no descarga nada. */
(function () {
  var SELECTOR = 'video[data-wim-lazy-video]';
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var saveData = navigator.connection && navigator.connection.saveData;
  if (reduceMotion || saveData || !('IntersectionObserver' in window)) return;

  var MAX_DIM = 720;
  var productCache = {};

  // Liquid solo expone el MP4 de 1080p; la versión ligera sale de /products/<handle>.js
  function lightSource(video) {
    if (video.dataset.wimSourced) return Promise.resolve();
    video.dataset.wimSourced = '1';
    var handle = video.dataset.wimProductHandle;
    var mediaId = Number(video.dataset.wimMediaId);
    if (!handle || !mediaId || !window.fetch) return Promise.resolve();
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    if (!productCache[handle]) {
      productCache[handle] = fetch(root + 'products/' + handle + '.js', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    }
    return productCache[handle].then(function (product) {
      if (!product || !product.media) return;
      var media = product.media.filter(function (m) { return m.id === mediaId; })[0];
      if (!media || !media.sources) return;
      var best = null, bestDim = 0;
      media.sources.forEach(function (src) {
        if (src.format !== 'mp4') return;
        var dim = Math.min(src.width || 0, src.height || 0);
        if (dim <= MAX_DIM && dim > bestDim) { best = src; bestDim = dim; }
      });
      if (!best) return;
      var source = video.querySelector('source');
      if (source && source.src.indexOf(best.url.split('?')[0].split('/').pop()) === -1) {
        source.src = best.url;
        if (best.mime_type) source.type = best.mime_type;
        video.load();
      }
    });
  }

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      var video = entry.target;
      if (entry.isIntersecting) {
        video.dataset.wimVisible = '1';
        lightSource(video).then(function () {
          if (video.dataset.wimVisible !== '1') return;
          var p = video.play();
          if (p && p.catch) p.catch(function () {});
        });
      } else {
        video.dataset.wimVisible = '0';
        if (!video.paused) video.pause();
      }

    });
  }, { threshold: 0.5 });

  function watch(root) {
    if (!root || !root.querySelectorAll) return;
    if (root.matches && root.matches(SELECTOR)) observer.observe(root);
    root.querySelectorAll(SELECTOR).forEach(function (v) { observer.observe(v); });
  }

  function init() {
    watch(document);
    // Listados que se recargan (filtros, paginación, quick view)
    new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        m.addedNodes.forEach(function (n) { if (n.nodeType === 1) watch(n); });
      });
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* WPO batería 4: las imágenes del mega menú y del menú móvil se pintan sin src
   (data-wim-menu-src / data-wim-menu-srcset) y solo se cargan cuando el usuario
   muestra intención de abrir el menú: pasar por la cabecera, foco con teclado o
   tocar el botón de menú. Antes se descargaban ~88 imágenes en cada página. */
(function () {
  var done = false;
  function activate() {
    if (done) return;
    done = true;
    document.querySelectorAll('img[data-wim-menu-src], img[data-wim-menu-srcset], source[data-wim-menu-srcset]').forEach(function (img) {
      if (img.dataset.wimMenuSrcset) img.setAttribute('srcset', img.dataset.wimMenuSrcset);
      if (img.dataset.wimMenuSrc) img.setAttribute('src', img.dataset.wimMenuSrc);
      img.removeAttribute('data-wim-menu-src');
      img.removeAttribute('data-wim-menu-srcset');
    });
  }
  function bind() {
    var header = document.querySelector('[id^="shopify-section-"][id$="__wim_header"]') || document;
    ['pointerover', 'focusin', 'touchstart'].forEach(function (ev) {
      header.addEventListener(ev, activate, { once: true, passive: true });
    });
    document.querySelectorAll('[data-drawer-toggle], .header__mobile__button, [aria-controls*="drawer"], .menu__item').forEach(function (el) {
      el.addEventListener('click', activate, { once: true });
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bind);
  } else {
    bind();
  }
})();

/* ==========================================================================
   WIM CRO · Ficha de producto
   D1 · Talla: por defecto llega marcada la 12 (o la que marque el tema si la 12 no está).
        Con el ajuste «Obligar a elegir talla» el botón pide «Elige tu talla» hasta que se elige.
   D2 · Aviso de tallas por encargo (sin devolución, 10-15 días) al elegirlas.
   Textos en snippets/wim-pdp-cro.liquid (data-*). Si la URL trae ?variant= se respeta.
   ========================================================================== */
(function () {
  function init() {
    var box = document.querySelector('[data-wim-pdp-cro]');
    if (!box) return;
    var form = box.parentElement.querySelector('form[data-product-form]') || document.querySelector('form[data-product-form]');
    var scope = box.closest('.shopify-section') || document;
    var fs = scope.querySelector('.product__selectors .radio__fieldset--variant-option-size');
    if (!form || !fs) return;
    var radios = function () { return Array.prototype.slice.call(fs.querySelectorAll('input[type="radio"]')); };
    if (radios().length < 2) return;

    var alertEl = box.querySelector('[data-wim-size-alert]');
    var btn = form.querySelector('[data-add-to-cart]');
    var btnText = btn && btn.querySelector('[data-add-to-cart-text]');
    var barText = document.querySelector('#cart-bar .btn__text');
    var barOrig = barText ? barText.textContent : '';
    var hasVariant = new URLSearchParams(location.search).has('variant');
    var need = box.dataset.requireSize === 'true' && !hasVariant;

    function showAlert(text, isError) {
      if (!alertEl) return;
      alertEl.textContent = text;
      alertEl.hidden = !text;
      alertEl.classList.toggle('is-error', !!isError);
    }

    function applyPending() {
      radios().forEach(function (i) { i.checked = false; i.removeAttribute('checked'); });
      var val = fs.querySelector('[data-option-value]');
      if (val) val.textContent = '';
      if (btnText) btnText.textContent = box.dataset.chooseSize;
      if (barText) barText.textContent = box.dataset.chooseSize;
      fs.classList.add('wim-size-pending');
    }

    // el aviso va justo debajo del selector de talla
    if (alertEl) fs.after(alertEl);

    // sin el ajuste «Obligar a elegir talla»: marca la talla de data-preselect-size (la primera de 12, 14 y 16 con stock real; vacío si todas están en preventa)
    function preselect() {
      var wanted = box.dataset.preselectSize;
      if (!wanted) return;
      var match = radios().filter(function (i) { return i.value === wanted && !i.disabled; })[0];
      if (match && !match.checked) match.click();
      var current = radios().filter(function (i) { return i.checked; })[0];
      var special = current && current.closest('.radio__button-variant-option-special');
      if (special) showAlert(box.dataset.special, false);
    }

    if (need) applyPending();
    else if (!hasVariant) preselect();

    fs.addEventListener('change', function (e) {
      if (!e.target.matches('input[type="radio"]')) return;
      need = false;
      fs.classList.remove('wim-size-pending', 'wim-size-error');
      if (barText && barOrig) barText.textContent = barOrig;
      var special = e.target.closest('.radio__button-variant-option-special');
      showAlert(special ? box.dataset.special : '', false);
    });

    function block(e) {
      if (!need) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      showAlert(box.dataset.needSize, true);
      fs.classList.add('wim-size-error');
      fs.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
    document.addEventListener('click', function (e) {
      var b = e.target.closest('[data-add-to-cart]');
      if (b && form.contains(b)) block(e);
    }, true);
    document.addEventListener('submit', function (e) { if (e.target === form) block(e); }, true);
    // Barra fija: mientras no hay talla, lleva al selector de talla
    document.addEventListener('click', function (e) {
      if (need && e.target.closest('#cart-bar .product__submit__add')) block(e);
    }, true);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { setTimeout(init, 60); });
  } else {
    setTimeout(init, 60);
  }
})();

/* ==========================================================================
   WIM CRO · Listados
   P7 · «Cargar más»: trae la página siguiente y añade sus productos a la rejilla.
   P1 · Descripción de colección plegada con «Leer más».
   ========================================================================== */
(function () {
  var L = (document.documentElement.lang || 'es').slice(0, 2);
  var T = {
    es: ['Leer más', 'Leer menos'], pt: ['Ler mais', 'Ler menos'], en: ['Read more', 'Read less'],
    fr: ['Lire la suite', 'Réduire'], it: ['Leggi di più', 'Leggi meno'], de: ['Mehr lesen', 'Weniger']
  }[L] || ['Leer más', 'Leer menos'];

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-wim-load-more-btn]');
    if (!btn) return;
    e.preventDefault();
    if (btn.classList.contains('is-loading')) return;
    var grid = document.getElementById('CollectionLoop');
    if (!grid) { location.href = btn.href; return; }
    btn.classList.add('is-loading');
    var url = btn.href;
    fetch(url, { credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var newGrid = doc.getElementById('CollectionLoop');
        if (!newGrid) { location.href = url; return; }
        Array.prototype.slice.call(newGrid.children).forEach(function (el) {
          if (el.classList.contains('product-item--featured-image')) return;
          el.querySelectorAll('[data-aos]').forEach(function (a) { a.classList.add('aos-animate'); });
          // las imágenes nuevas no tienen el listener del tema que quita «is-loading»
          el.querySelectorAll('img').forEach(function (img) {
            var done = function () {
              img.classList.remove('is-loading');
              el.querySelectorAll('.is-loading').forEach(function (w) { if (w.contains(img)) w.classList.remove('is-loading'); });
            };
            if (img.complete && img.naturalWidth) done(); else img.addEventListener('load', done, { once: true });
          });
          el.classList.add('aos-animate');
          grid.appendChild(el);
        });
        var oldBox = btn.closest('[data-wim-load-more]');
        var newBox = doc.querySelector('[data-wim-load-more]');
        var oldNav = oldBox && oldBox.parentElement.querySelector('.pagination-custom');
        var newNav = doc.querySelector('.pagination-custom');
        if (oldNav && newNav) oldNav.replaceWith(newNav);
        if (oldBox && newBox) oldBox.replaceWith(newBox);
        try { history.replaceState(history.state, '', url); } catch (err) {}
        document.dispatchEvent(new CustomEvent('wim:products-appended'));
      })
      .catch(function () { location.href = url; });
  });

  function initClamp(root) {
    (root || document).querySelectorAll('[data-wim-clamp]').forEach(function (el) {
      if (el.dataset.wimClampReady) return;
      // wim-custom.css carga en diferido: si su recorte aún no se aplica, medir ahora daría «no hace falta» y el texto quedaría abierto
      if (getComputedStyle(el).overflow !== 'hidden' || !el.clientHeight) {
        var tries = +(el.dataset.wimClampTries || 0);
        if (tries < 40) { el.dataset.wimClampTries = tries + 1; setTimeout(function () { initClamp(root); }, 150); }
        return;
      }
      el.dataset.wimClampReady = '1';
      if (el.scrollHeight <= el.clientHeight + 4) { el.classList.add('wim-clamp--open'); return; }
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'wim-clamp__toggle';
      b.textContent = T[0];
      b.setAttribute('aria-expanded', 'false');
      b.addEventListener('click', function () {
        var open = el.classList.toggle('wim-clamp--open');
        b.textContent = open ? T[1] : T[0];
        b.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
      el.after(b);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initClamp(); });
  else initClamp();
})();

/* WIM CRO P5 · en listados, las joyas agotadas pasan al final de la rejilla */
(function () {
  function sink() {
    var grid = document.getElementById('CollectionLoop');
    if (!grid) return;
    var kids = Array.prototype.slice.call(grid.children);
    var firstSold = kids.findIndex(function (el) { return el.classList.contains('wim-soldout'); });
    if (firstSold < 0) return;
    var needs = kids.slice(firstSold).some(function (el) { return el.classList.contains('product-item') && !el.classList.contains('wim-soldout') && !el.classList.contains('product-item--featured-image'); });
    if (!needs) return;
    grid.querySelectorAll(':scope > .wim-soldout').forEach(function (el) { grid.appendChild(el); });
  }
  // P2 · al filtrar, el tema solo recarga la rejilla: actualizamos el recuento de la cabecera
  function syncCount() {
    var t = document.querySelector('[data-wim-total]');
    var c = document.querySelector('.wim-collection-count');
    if (!t || !c) return;
    var n = t.getAttribute('data-wim-total');
    var txt = c.textContent.replace(/^\s*[\d.]+/, n);
    if (txt !== c.textContent) c.textContent = txt;
  }
  var _sink = sink;
  sink = function () { _sink(); syncCount(); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', sink); else sink();
  document.addEventListener('wim:products-appended', sink);
  document.addEventListener('theme:filters:updated', sink);
  new MutationObserver(function (m) {
    if (m.some(function (r) { return r.addedNodes.length && (r.target.id === 'CollectionLoop' || (r.target.querySelector && r.target.querySelector('#CollectionLoop'))); })) setTimeout(sink, 0);
  }).observe(document.documentElement, { childList: true, subtree: true });
})();

/* WIM CRO D1 · D2 en la compra rápida de los listados: misma regla que en la ficha
   (sin talla marcada, «Elige tu talla» y aviso de tallas por encargo). */
(function () {
  var L = (document.documentElement.lang || 'es').slice(0, 2);
  var T = {
    es: ['Elige tu talla', 'Elige una talla antes de añadir a la cesta.', 'Talla por encargo: entrega en 10-15 días hábiles y sin devolución. Las tallas 12, 14 y 16 sí admiten devolución.'],
    pt: ['Escolhe o teu tamanho', 'Escolhe um tamanho antes de adicionar ao cesto.', 'Tamanho por encomenda: entrega em 10-15 dias úteis e sem devolução. Os tamanhos 12, 14 e 16 têm devolução.'],
    en: ['Choose your size', 'Please choose a size before adding to bag.', 'Made-to-order size: delivery in 10-15 working days and not returnable. Sizes 12, 14 and 16 can be returned.'],
    fr: ['Choisissez votre taille', 'Choisissez une taille avant d’ajouter au panier.', 'Taille sur commande : livraison en 10-15 jours ouvrés, sans retour. Les tailles 12, 14 et 16 peuvent être retournées.'],
    it: ['Scegli la tua misura', 'Scegli una misura prima di aggiungere al carrello.', 'Misura su ordinazione: consegna in 10-15 giorni lavorativi, senza reso. Le misure 12, 14 e 16 si possono rendere.'],
    de: ['Größe wählen', 'Bitte wähle eine Größe, bevor du sie in den Warenkorb legst.', 'Größe auf Bestellung: Lieferung in 10-15 Werktagen, keine Rückgabe. Größen 12, 14 und 16 können zurückgegeben werden.']
  }[L] || ['Elige tu talla', 'Elige una talla antes de añadir a la cesta.', 'Talla por encargo: entrega en 10-15 días hábiles y sin devolución.'];

  function guard(dialog) {
    var fs = dialog.querySelector('.radio__fieldset--variant-option-size');
    var form = dialog.querySelector('form[data-product-form]');
    if (!fs || !form || form.dataset.wimGuard) return;
    var radios = fs.querySelectorAll('input[type="radio"]');
    if (radios.length < 2) return;
    form.dataset.wimGuard = '1';
    var need = true;
    var btnText = form.querySelector('[data-add-to-cart] [data-add-to-cart-text]');
    var alertEl = document.createElement('p');
    alertEl.className = 'wim-pdp-cro__alert';
    alertEl.setAttribute('role', 'alert');
    alertEl.hidden = true;
    fs.after(alertEl);
    radios.forEach(function (i) { i.checked = false; i.removeAttribute('checked'); });
    var val = fs.querySelector('[data-option-value]');
    if (val) val.textContent = '';
    if (btnText) btnText.textContent = T[0];
    fs.addEventListener('change', function (e) {
      if (!e.target.matches('input[type="radio"]')) return;
      need = false;
      fs.classList.remove('wim-size-error');
      var special = e.target.closest('.radio__button-variant-option-special');
      alertEl.textContent = special ? T[2] : '';
      alertEl.hidden = !special;
      alertEl.classList.remove('is-error');
    });
    function block(e) {
      if (!need) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      alertEl.textContent = T[1];
      alertEl.hidden = false;
      alertEl.classList.add('is-error');
      fs.classList.add('wim-size-error');
    }
    document.addEventListener('submit', function (e) { if (e.target === form) block(e); }, true);
    document.addEventListener('click', function (e) {
      var b = e.target.closest('[data-add-to-cart]');
      if (b && form.contains(b)) block(e);
    }, true);
  }
  new MutationObserver(function () {
    document.querySelectorAll('dialog.product-quick-add').forEach(function (d) {
      if (d.querySelector('form[data-product-form]:not([data-wim-guard])')) setTimeout(function () { guard(d); }, 50);
    });
  }).observe(document.documentElement, { childList: true, subtree: true });
})();

/* WIM · Botón flotante «Filtros» en los listados (8-oct, referencia Louis Vuitton, pedido de Mumit).
   Se oculta la barra de filtros/orden y un botón fijo abajo abre un panel lateral con «Ordenar por», los filtros del tema y «Ver resultados».
   El formulario sigue siendo el del tema: al filtrar reescribe el contenido de [data-collection-sidebar], que se mueve dentro del panel. */
(function () {
  var L = (document.documentElement.lang || 'es').slice(0, 2);
  var T = {
    es: ['Filtros y ordenar', 'Filtrar y ordenar', 'Ordenar por', 'Ver resultados', 'Ver {n} resultados', 'Borrar todo', 'Cerrar'],
    pt: ['Filtros e ordenar', 'Filtrar e ordenar', 'Ordenar por', 'Ver resultados', 'Ver {n} resultados', 'Limpar tudo', 'Fechar'],
    en: ['Filter & sort', 'Filter and sort', 'Sort by', 'Show results', 'Show {n} results', 'Clear all', 'Close'],
    fr: ['Filtrer et trier', 'Filtrer et trier', 'Trier par', 'Voir les résultats', 'Voir {n} résultats', 'Tout effacer', 'Fermer'],
    it: ['Filtri e ordina', 'Filtra e ordina', 'Ordina per', 'Vedi risultati', 'Vedi {n} risultati', 'Cancella tutto', 'Chiudi'],
    de: ['Filtern & sortieren', 'Filtern und sortieren', 'Sortieren nach', 'Ergebnisse anzeigen', '{n} Ergebnisse anzeigen', 'Alle löschen', 'Schließen']
  }[L] || ['Filtros y ordenar', 'Filtrar y ordenar', 'Ordenar por', 'Ver resultados', 'Ver {n} resultados', 'Borrar todo', 'Cerrar'];

  function init() {
    var section = document.querySelector('[data-section-type="collection"]');
    if (!section || section.classList.contains('wim-ff')) return;
    var sb = section.querySelector('[data-collection-sidebar]');
    var nav = section.querySelector('[data-collection-nav]');
    if (!sb) return;
    section.classList.add('wim-ff');

    var drawer = document.createElement('aside');
    drawer.className = 'wim-ff-drawer';
    drawer.setAttribute('role', 'dialog');
    drawer.setAttribute('aria-modal', 'true');
    drawer.setAttribute('aria-label', T[1]);
    drawer.innerHTML =
      '<div class="wim-ff-drawer__head"><span>' + T[1] + '</span><button type="button" class="wim-ff-x" aria-label="' + T[6] + '">&times;</button></div>' +
      '<div class="wim-ff-drawer__body"><div class="wim-ff-sort"></div></div>' +
      '<div class="wim-ff-drawer__foot"><button type="button" class="wim-ff-clear" hidden>' + T[5] + '</button><button type="button" class="wim-ff-go">' + T[3] + '</button></div>';
    var overlay = document.createElement('div');
    overlay.className = 'wim-ff-overlay';
    var body = drawer.querySelector('.wim-ff-drawer__body');
    section.appendChild(overlay);
    section.appendChild(drawer);
    body.appendChild(sb);
    sb.querySelectorAll('details').forEach(function (d) { d.open = false; });

    // «Ordenar por»: lista con las mismas opciones del tema; al elegir se pulsa el enlace original
    var sortBox = drawer.querySelector('.wim-ff-sort');
    var links = nav ? nav.querySelectorAll('[data-sort-link]') : [];
    if (links.length) {
      var html = '<p class="wim-ff-sort__title">' + T[2] + '</p><ul>';
      links.forEach(function (a, i) {
        var on = a.closest('li') && a.closest('li').classList.contains('is-active');
        html += '<li><button type="button" data-i="' + i + '" aria-pressed="' + (on ? 'true' : 'false') + '">' + a.textContent.trim() + '</button></li>';
      });
      sortBox.innerHTML = html + '</ul>';
      sortBox.addEventListener('click', function (e) {
        var b = e.target.closest('button[data-i]');
        if (!b) return;
        sortBox.querySelectorAll('button').forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
        links[+b.dataset.i].click();
      });
    } else {
      sortBox.remove();
    }

    var fab = document.createElement('button');
    fab.type = 'button';
    fab.className = 'wim-ff-fab';
    fab.innerHTML = '<svg aria-hidden="true" viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"><path d="M4 7h10M18 7h2M4 17h4M12 17h8"/><circle cx="16" cy="7" r="2"/><circle cx="10" cy="17" r="2"/></svg><span>' + T[0] + '</span><span class="wim-ff-fab__n" hidden></span>';
    document.body.appendChild(fab);

    function activeCount() {
      var el = sb.querySelector('[data-active-filters-count]');
      return el ? parseInt(el.getAttribute('data-active-filters-count'), 10) || 0 : 0;
    }
    function total() {
      var t = section.querySelector('[data-wim-total]');
      return t ? t.getAttribute('data-wim-total') : '';
    }
    function refresh() {
      var n = activeCount();
      var badge = fab.querySelector('.wim-ff-fab__n');
      badge.hidden = !n;
      badge.textContent = n;
      drawer.querySelector('.wim-ff-clear').hidden = !n;
      var tt = total();
      drawer.querySelector('.wim-ff-go').textContent = tt ? T[4].replace('{n}', tt) : T[3];
    }
    function open() {
      refresh();
      document.documentElement.classList.add('wim-ff-open');
      setTimeout(function () { var x = drawer.querySelector('.wim-ff-x'); if (x) x.focus(); }, 50);
    }
    function close() {
      document.documentElement.classList.remove('wim-ff-open');
      fab.focus();
    }
    fab.addEventListener('click', open);
    overlay.addEventListener('click', close);
    drawer.querySelector('.wim-ff-x').addEventListener('click', close);
    drawer.querySelector('.wim-ff-go').addEventListener('click', close);
    drawer.querySelector('.wim-ff-clear').addEventListener('click', function () {
      var a = sb.querySelector('.active__filters__clear, .collection__sidebar__buttons a[data-filter-update-url]');
      if (a) { a.click(); return; }
      var r = sb.querySelectorAll('.active__filters__remove');
      if (r.length) r[0].click();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && document.documentElement.classList.contains('wim-ff-open')) close();
    });

    // el aviso fijo de la app (abajo) taparía el botón: lo subimos por encima mientras se vea
    function lift() {
      var w = document.querySelector('.app_advertise_wrapper');
      var h = 0;
      if (w) { var r = w.getBoundingClientRect(); if (r.height && r.top < window.innerHeight && getComputedStyle(w).display !== 'none') h = Math.max(0, window.innerHeight - r.top); }
      fab.style.setProperty('--wim-ff-lift', h + 'px');
    }
    lift();
    // el aviso de la app se inyecta tarde: vigilamos el body y repasamos unos segundos
    new MutationObserver(lift).observe(document.body, { childList: true });
    var liftN = 0, liftT = setInterval(function () { lift(); if (++liftN > 20) clearInterval(liftT); }, 500);
    window.addEventListener('resize', lift);
    window.addEventListener('scroll', lift, { passive: true });
    document.addEventListener('click', function () { setTimeout(lift, 300); });

    // tras filtrar, el tema reescribe los filtros: se reabre el grupo con el que se estaba trabajando
    var lastGroup = null;
    function gName(d) { var x = d && d.querySelector('summary span'); return x ? x.textContent.trim() : null; }
    sb.addEventListener('click', function (e) {
      var sum = e.target.closest('.filter-group summary');
      if (sum) setTimeout(function () { lastGroup = sum.parentElement.open ? gName(sum.parentElement) : null; }, 0);
    });
    new MutationObserver(function () {
      refresh();
      if (lastGroup) sb.querySelectorAll('.filter-group details').forEach(function (d) {
        if (gName(d) === lastGroup) { d.open = true; d.setAttribute('open', 'true'); var b = d.querySelector('[data-collapsible-body]'); if (b) b.style.height = 'auto'; }
      });
    }).observe(sb, { childList: true });
    var grid = section.querySelector('[data-products-grid]');
    if (grid) new MutationObserver(refresh).observe(grid, { childList: true });
    refresh();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
/* Bloques «Featured image» del listado: en móvil, sin cards al lado, toman el alto natural de una card */
(function () {
  function naturalHeight(card) {
    var cs = getComputedStyle(card);
    var h = parseFloat(cs.paddingTop) + parseFloat(cs.paddingBottom) + parseFloat(cs.borderTopWidth) + parseFloat(cs.borderBottomWidth);
    Array.prototype.forEach.call(card.children, function (child) {
      var c = getComputedStyle(child);
      if (c.position === 'absolute' || c.position === 'fixed' || c.display === 'none') return;
      h += child.getBoundingClientRect().height + parseFloat(c.marginTop) + parseFloat(c.marginBottom);
    });
    return h;
  }

  function sync(grid) {
    if (!grid.querySelector('.product-item--featured-span')) return;
    var cards = grid.querySelectorAll(':scope > .product-item:not(.product-item--featured-image)');
    var max = 0;
    Array.prototype.forEach.call(cards, function (card) { max = Math.max(max, naturalHeight(card)); });
    if (!max) return;
    var height = max.toFixed(2) + 'px';
    var gap = getComputedStyle(grid).rowGap;
    if (grid.style.getPropertyValue('--wim-card-height') !== height) grid.style.setProperty('--wim-card-height', height);
    if (gap && gap !== 'normal' && grid.style.getPropertyValue('--wim-row-gap') !== gap) grid.style.setProperty('--wim-row-gap', gap);
  }

  function bind() {
    var grid = document.getElementById('CollectionLoop');
    if (!grid || grid.wimFeaturedBound) return;
    grid.wimFeaturedBound = true;
    var queued = false;
    var schedule = function () {
      if (queued) return;
      queued = true;
      requestAnimationFrame(function () { queued = false; sync(grid); });
    };
    if (window.ResizeObserver) new ResizeObserver(schedule).observe(grid);
    new MutationObserver(schedule).observe(grid, { childList: true });
    grid.addEventListener('load', schedule, true);
    schedule();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bind); else bind();
  new MutationObserver(bind).observe(document.documentElement, { childList: true, subtree: true });
})();
